import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../styles'
import TextEllipsis from '../core/TextEllipsis'

export type BadgeProps = {
  className?: string
  color?: string
  description: string
  href: string
  icon: string
  title: string
  total?: number | null
}

/** Badge component is used for badges on user page */
function BadgeComponent({
  className,
  color,
  description,
  href,
  icon,
  title,
  total,
}: BadgeProps): React.ReactElement<BadgeProps> {
  return (
    <S.badge.Wrapper href={href} className={className}>
      <S.badge.Icon color={color}>
        <img src={icon} alt={title} />
      </S.badge.Icon>
      <S.badge.Content>
        <S.badge.Title color={color}>{title}</S.badge.Title>
        <TextEllipsis lines={3} tag={'div'} ellipsisChars={'...'} tagClass={'className'} useJsOnly={true}>
          <S.badge.Description>{description}</S.badge.Description>
        </TextEllipsis>
      </S.badge.Content>
      {total !== null && (
        <S.badge.Infos $color={color}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path
              fill="#fff"
              d="M21 18.28H10.56A8.35 8.35 0 0 0 2 26.42v3.32A2.16 2.16 0 0 0 4 32h.29a2.17 2.17 0 0 0 2.31-2 2.12 2.12 0 0 0 0-.28v-3a3.74 3.74 0 0 1 3.6-3.89h11.2a3.89 3.89 0 0 1 3.93 3.84v3a2.16 2.16 0 0 0 2 2.29h.29A2.17 2.17 0 0 0 30 30a2.12 2.12 0 0 0 0-.28v-3a9 9 0 0 0-9-8.44zM15.88 0a8.49 8.49 0 0 0-8.55 8.41 8.3 8.3 0 0 0 8.37 8.23h.19a8.49 8.49 0 0 0 8.56-8.41A8.58 8.58 0 0 0 15.88 0zm0 12.11A3.84 3.84 0 0 1 12 8.46a4 4 0 0 1 3.93-3.89 3.89 3.89 0 0 1 3.93 3.84 3.82 3.82 0 0 1-3.98 3.7z"
            />
          </svg>
          <span>{total}</span>
        </S.badge.Infos>
      )}
    </S.badge.Wrapper>
  )
}

export const Badge = styled(BadgeComponent)<BadgeProps>``
Badge.displayName = 'Badge'
